import { globals } from '@/src/globals'
declare const Masonry

export const masonryCaseStudies = (): void => {
  const allCaseStudiesLists = document.querySelectorAll('.js-caseStudyList_2022') as unknown as HTMLElement[]

  if (allCaseStudiesLists.length > 0) {
    allCaseStudiesLists.forEach((caseStudiesList: HTMLElement) => {
      const caseStudiesWrapper = caseStudiesList.querySelector('.js-caseStudyList_2022-studySingleMasonryWrapper') as unknown as HTMLElement

      const masonry = new Masonry(caseStudiesWrapper, {
        itemSelector: '.js-caseStudyList_2022-studySingleMasonry',
        horizontalOrder: true,
        transitionDuration: 0
      })

      globals.masonryList.push(masonry)
    })
  }
}
